'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' });

var Close = function Close(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Close = (0, _pure2.default)(Close);
Close.muiName = 'SvgIcon';

exports.default = Close;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Close.js
// module id = 2255
// module chunks = 0